import React from 'react';
import {lightGray, darkGray} from '../styles/colors'
import '../styles/index.css';

const ValidationItem = (text, condition) => {
    return (
      <span
        className="list-item"
        style={{
          color: condition ? lightGray : darkGray ,
        }}
      >
        {` \u2022 ${text}`}
      </span>
    );
  };
export default ValidationItem;
